import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { array, string, func } from 'prop-types'
import { stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import Icon from 'components/Icon'
import { grey, greyDark, offWhite } from 'styles/colors'
import { fontWeights } from 'styles/typography'

import DownChevron from 'icons/down-chevron.svg'

const Container = styled.div`
  position: relative;
  display: block;
  width: 100%;
`

const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.small} ${spacing.large};
  width: 100%;
  text-align: left;
  align-items: center;
  font-weight: ${fontWeights.bold};
  cursor: pointer;
  color: ${greyDark};
`

const Chevron = styled.div`
  display: flex;
  color: ${greyDark};
  transform: ${props => (props.flipped ? 'rotate(180deg)' : 'none')};
`

const Menu = styled.div`
  position: relative;
  background-color: ${offWhite};
  display: flex;
  flex-wrap: wrap;
  padding: ${stripUnit(spacing.small) * 1.5 + 'px'} 0;
  margin: ${spacing.small} 0;
`

const Item = styled(Link)`
  display: block;
  color: ${grey};
  font-weight: ${fontWeights.medium};
  padding: ${spacing.small} ${spacing.large};
  flex-basis: 50%;
`

const MobileNavItem = ({ label, items, href, link, hideNav, ...rest }) => {
  const [visibility, setVisibility] = useState(false)

  return (
    <Container {...rest}>
      {items ? (
        <Trigger
          onClick={() => {
            setVisibility(!visibility)
          }}
        >
          {label}
          {items && (
            <Chevron flipped={visibility ? 'true' : undefined}>
              <Icon icon={<DownChevron />} />
            </Chevron>
          )}
        </Trigger>
      ) : (
        <>
          {link ? (
            <Trigger to={link} as={Link} onClick={hideNav}>
              {label}
            </Trigger>
          ) : (
            <Trigger as="a" href={href}>
              {label}
            </Trigger>
          )}
        </>
      )}
      {items && visibility ? (
        <Menu>
          {items.map((item, i) => (
            <Item to={item.link} key={i} onClick={hideNav}>
              {item.label}
            </Item>
          ))}
        </Menu>
      ) : null}
    </Container>
  )
}

MobileNavItem.propTypes = {
  label: string.isRequired,
  link: string,
  items: array,
  hideNav: func
}

export default MobileNavItem
